import { useState } from "react";

export function useFileInput(validationFunction) {
  const [file, setFile] = useState(null);
  const [didEdit, setDidEdit] = useState(false);
  const [waitingForDialog, setWaitingForDialog] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setDidEdit(true);

    if (validationFunction) {
      const validationResult = validationFunction(selectedFile);
      setError(validationResult);
    }
  };

  const handleFileBlur = () => {
    setDidEdit(true);
    if (validationFunction) {
      const validationResult = validationFunction(file);
      setError(validationResult);
    }
  };

  const handleFileDialogStart = () => {
    setWaitingForDialog(true);

    const onFocus = () => {
      setWaitingForDialog(false);
      setDidEdit(true);
      try {
        if (validationFunction) {
          const validationResult = validationFunction(file);
          setError(validationResult);
        }
      } finally {
        window.removeEventListener("focus", onFocus);
      }
    };

    window.addEventListener("focus", onFocus, { once: true });
  };

  const handleFileDrop = (file) => {
    setFile(file);
    setDidEdit(true);

    if (validationFunction) {
      const validationResult = validationFunction(file);
      setError(validationResult);
    }
  };

  const reset = () => {
    setFile(null);
    setDidEdit(false);
    setError("");
  };

  const isValid = validationFunction ? validationFunction(file) === "" : true;

  return {
    file,
    setFile,
    handleFileChange,
    handleFileDrop,
    handleFileBlur,
    handleFileDialogStart,
    hasError: didEdit && !isValid,
    error: didEdit ? error : "",
    reset,
  };
}
